"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpButton = exports.LoginModal = exports.LoginModalContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const dfinity_logo_svg_1 = __importDefault(require("src/hello_assets/assets/dfinity_logo.svg"));
const nfid_logo_svg_1 = __importDefault(require("src/hello_assets/src/components/ui/anonymous/assets/nfid_logo.svg"));
const plug_logo_svg_1 = __importDefault(require("src/hello_assets/src/components/ui/anonymous/assets/plug_logo.svg"));
const infinitywallet_logo_png_1 = __importDefault(require("src/hello_assets/src/components/ui/anonymous/assets/infinitywallet_logo.png"));
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const canisters_1 = require("src/hello_assets/src/util/canisters");
const assetCanisterUtills_1 = require("src/hello_assets/src/util/assetCanisterUtills");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const MixpanelAnalytics_1 = require("src/hello_assets/src/util/analytics/MixpanelAnalytics");
const derivationOriginFromIOToAPP = (0, assetCanisterUtills_1.getDerivationOriginFromIOToAPP)(window.location.host, canisters_1.Canisters.frontend);
exports.LoginModalContext = React.createContext(undefined);
const LoginModal = (props) => {
    const { login } = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const [visible, setVisible] = (0, react_1.useState)(false);
    const showModal = (0, react_1.useCallback)(() => setVisible(true), []);
    const onClickII = (0, react_1.useCallback)(async () => {
        var _a;
        setVisible(false);
        const source = "II";
        const loginResult = await login({ source, derivationOrigin: derivationOriginFromIOToAPP });
        if (loginResult.status === "success") {
            MixpanelAnalytics_1.MixpanelAnalytics.Business.trackSignIn({ source, derivationOrigin: derivationOriginFromIOToAPP });
        }
        else if (loginResult.status === "error") {
            MixpanelAnalytics_1.MixpanelAnalytics.Tech.trackSignInError(((_a = loginResult.error) === null || _a === void 0 ? void 0 : _a.message) || "unknownError", { source });
        }
    }, []);
    const onClickNFID = (0, react_1.useCallback)(async () => {
        var _a;
        setVisible(false);
        const source = "NFID";
        const loginResult = await login({ source, derivationOrigin: derivationOriginFromIOToAPP });
        if (loginResult.status === "success") {
            MixpanelAnalytics_1.MixpanelAnalytics.Business.trackSignIn({ source, derivationOrigin: derivationOriginFromIOToAPP });
        }
        else if (loginResult.status === "error") {
            MixpanelAnalytics_1.MixpanelAnalytics.Tech.trackSignInError(((_a = loginResult.error) === null || _a === void 0 ? void 0 : _a.message) || "unknownError", { source });
        }
    }, []);
    const onClickPlug = (0, react_1.useCallback)(async () => {
        var _a;
        setVisible(false);
        const source = "Plug";
        const loginResult = await login({ source, derivationOrigin: undefined });
        if (loginResult.status === "success") {
            MixpanelAnalytics_1.MixpanelAnalytics.Business.trackSignIn({ source: source });
        }
        else if (loginResult.status === "error") {
            MixpanelAnalytics_1.MixpanelAnalytics.Tech.trackSignInError(((_a = loginResult.error) === null || _a === void 0 ? void 0 : _a.message) || "unknownError", { source });
        }
    }, []);
    const onClickInfinityWallet = (0, react_1.useCallback)(async () => {
        var _a;
        setVisible(false);
        const source = "InfinityWallet";
        const loginResult = await login({ source, derivationOrigin: undefined });
        if (loginResult.status === "success") {
            MixpanelAnalytics_1.MixpanelAnalytics.Business.trackSignIn({ source: source });
        }
        else if (loginResult.status === "error") {
            MixpanelAnalytics_1.MixpanelAnalytics.Tech.trackSignInError(((_a = loginResult.error) === null || _a === void 0 ? void 0 : _a.message) || "unknownError", { source });
        }
    }, []);
    const handleCancel = (0, react_1.useCallback)(() => setVisible(false), []);
    const footer = [
        React.createElement(antd_1.Button, { key: "signUpWithII", onClick: onClickII, icon: React.createElement("img", { src: dfinity_logo_svg_1.default, alt: "", style: { width: 43, paddingRight: 10 } }) }, "Internet Identity"),
        React.createElement(antd_1.Button, { key: "signUpWithNFID", onClick: onClickNFID, icon: React.createElement("img", { src: nfid_logo_svg_1.default, alt: "", style: { width: 52, paddingRight: 10 } }) }, "NFID"),
        React.createElement(antd_1.Button, { key: "signUpWithPlug", onClick: onClickPlug, icon: React.createElement("img", { src: plug_logo_svg_1.default, alt: "", style: { width: 23, paddingRight: 10 } }) }, "Plug"),
        React.createElement(antd_1.Button, { key: "signUpWithInfinityWallet", icon: React.createElement("img", { src: infinitywallet_logo_png_1.default, alt: "", style: { width: 14, margin: "0 9px 1px 0" } }), onClick: onClickInfinityWallet }, "Infinity Wallet"),
    ];
    const modalContent = React.createElement(React.Fragment, null,
        "By logging in you agree to our ",
        React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.legal(), target: "_blank" }, "Terms of Service"));
    const contextValue = (0, react_1.useMemo)(() => {
        return {
            showModal: showModal
        };
    }, [showModal]);
    return React.createElement(React.Fragment, null,
        React.createElement(exports.LoginModalContext.Provider, { value: contextValue },
            React.createElement(antd_1.Modal, { visible: visible, title: "Login", footer: footer, closable: true, onCancel: handleCancel, width: 650 }, modalContent),
            props.children));
};
exports.LoginModal = LoginModal;
const SignUpButton = () => {
    return React.createElement(exports.LoginModal, null,
        React.createElement(exports.LoginModalContext.Consumer, null, (context) => {
            return context ? React.createElement(antd_1.Button, { onClick: context.showModal, shape: "round", type: "primary", className: "linkActionButton" }, "Login") : null;
        }));
};
exports.SignUpButton = SignUpButton;
